// components/Footer.jsx
import bg from '../assets/background.webp';
import footerLogo from '../assets/logo2dark.png';

export default function Footer({ t, language }) {
  // Определяем порядок: для русского меняем местами
  const isRussian = language === 'RU';

  return (
    <footer className="relative bg-[#0B3B6F] text-white px-3 py-20 md:px-10 rounded-none overflow-hidden">

      {/* Фоновое изображение */}
      <div
        className="absolute inset-0 pointer-events-none rounded-none z-0"
        style={{
          backgroundImage: `url(${bg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      />

      <div className="mx-auto max-w-7xl relative z-10">

        <div className="grid gap-10 md:grid-cols-4">
          <img src={footerLogo} className="bg-blend-multiply" alt="NWTA Logo" />

          {/* Контакты */}
          <div>
            <h4 className="text-sm font-bold text-[#0FA4E8] uppercase tracking-wider mb-4">
              National Water Technologies Armenia LLC
            </h4>
            <div className="space-y-3">
              <p className="text-sm text-slate-300 flex items-center gap-3">
                <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-white/10 text-[#0FA4E8]">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </span>
                {t.footerAddress}
              </p>
              <p className="text-sm text-slate-300 flex items-center gap-3">
                <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-white/10 text-[#0FA4E8]">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                </span>
                {t.footerPhone}
              </p>
              <p className="text-sm text-slate-300 flex items-center gap-3">
                <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-white/10 text-[#0FA4E8]">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                </span>
                {t.footerEmail}
              </p>
            </div>
          </div>

          {/* Быстрое меню */}
          <div>
            <h4 className="text-sm font-bold text-[#0FA4E8] uppercase tracking-wider mb-4">
              {t.quickMenu}
            </h4>
            <div className="space-y-2">
              {[
                { href: '#home', label: t.homeLink },
                { href: '#about', label: t.aboutTitle },
                { href: '#challenges', label: t.challengesTitle || t.problemsTitle },
                { href: '#solutions-page', label: t.solutionsTitle },
                { href: '#industries', label: t.industriesTitle },
                { href: '#partners', label: t.partnersPageTitle },
                { href: '#projects', label: t.projectsTitle },
                { href: '#blog', label: t.newsTitle || t.blogTitle },
                { href: '#contact', label: t.contactTitle }
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="block text-sm text-slate-300 hover:text-white hover:translate-x-1 transition-all"
                >
                  → {item.label}
                </a>
              ))}
            </div>
          </div>

          {/* Соцсети */}
          <div>
            <h4 className="text-sm font-bold text-[#0FA4E8] uppercase tracking-wider mb-4">
              {t.socialTitle}
            </h4>
            <div className="space-y-2">
              {[
                { name: 'Facebook', url: 'https://www.facebook.com/share/1Fzs4GyAxY/' },
                { name: 'Instagram', url: 'https://www.instagram.com/nwt.am?igsh=MTQwcjdiYzM1MXU0aQ==' },
                { name: 'YouTube', url: 'https://youtube.com/@nationalwatertechnologyarmenia?si=RY4lHcbUdkjoPqwr' }
              ].map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-sm text-slate-300 hover:text-white hover:translate-x-1 transition-all"
                >
                  <span className="w-2 h-2 bg-[#0FA4E8] flex-shrink-0" />
                  {social.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Копирайт */}
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-400">
          <p className="text-sm text-slate-300">{t.footerRights}</p>
          <p className="text-sm text-slate-300">
            {isRussian ? (
              <>
                {t.websitetext1} {t.websitetext2}{' '}
                <a href="https://timetocode.vercel.app" target="_blank" rel="noopener noreferrer" className="text-[#0FA4E8] font-bold hover:underline">TIME TO CODE</a>
              </>
            ) : (
              <>
                {t.websitetext1}{' '}
                <a href="https://timetocode.vercel.app" target="_blank" rel="noopener noreferrer" className="text-[#0FA4E8] font-bold hover:underline">TIME TO CODE</a>{' '}
                {t.websitetext2}
              </>
            )}
          </p>
        </div>
      </div>
    </footer>
  );
}